import { STATUS_CODE } from '@/lib/constants'
import oh from '@/lib/object_helper'
import auth from '@/lib/auth_client'
import request from '@/lib/request'

const account = {
  namespaced: true,
  state: { // 기본값은 꼭 챙겨줘야한다. reactive를 위해
    pharm_id: null,
    pharm_name: null,
    email: null,
    pharm_img: null,
    pharm_img_sm: null, // original 이미지 경로가 필요할까?
    is_searchable_on: null,
    is_domestic_on: null,
    is_overseas_on: null,
    is_available: null,
    pharm_intro: null,
    pharmacy_id: null,
    pharmacy_name: null, // Todo: 이건 가져와야지
    rec_stars: 0, // 이거 필요한가?,
    last_login_at: '',
    is_admin: null,
    is_pharm_admin: null, //병원관리 권한 kjw 20200325
  },
  actions: {
    async getPharm ({commit, dispatch}, pharm_id) {

      commit('setPharmId', pharm_id)

      if (!this.pharm_id) {
        let {data: {resp}} = await request.get(`pharmacist/${pharm_id}`)

        commit('loadPharmData', resp)
        // dispatch('getRecDrs') // 의사 정보를 불러오고 난 후에는 추천하는 의사들 목록을 불러온다.
      }
    },
    clearPharm ({commit}) {
      commit('setPharmData', ['pharm_name', ''])
    },
    async set_searchable_on({state, commit}, is_searchable = true) {
      let {data: {resp}} = await request.post(`pharmacist/${state.pharm_id}`, {is_searchable_on: is_searchable})
      commit('setPharmData', ['is_searchable_on', is_searchable])
    },
  },
  mutations: {
    // localstorage 에 기록된 정보가 있으면 request를 날려서 가져온다.
    setPharmData (state, [field, data]) {
      // console.log('setPharmData')
      state[field] = data
    },
    loadPharmData (state, pharm_obj) {
      let maintain_keys = Object.keys(state)

      for (let key of maintain_keys) {
        state[key] = pharm_obj[key]
      }
    },
    setPharmId (state, pharm_id) {
      state.pharm_id = pharm_id
    }
  }
}

export default account
